module.exports = __webpack_public_path__ + "fonts/aktivgroteskcorp-light.4cf58d7.woff2";